import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3fa8dcfe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3fa8dcfe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8dcfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa8dcfe')) {
      api.createRecord('3fa8dcfe', component.options)
    } else {
      api.reload('3fa8dcfe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3fa8dcfe&scoped=true", function () {
      api.rerender('3fa8dcfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/metaMaskInit/index.vue"
export default component.exports